import React, { useEffect, useState } from "react";
import Popup from '../../../../../presentationals/Popup/Popup.component';
import { saveBusinessTargetSubCategoryData, updateBusinessTargetSubCategoryData, getAllBusinessTargetCategory } from "../../targetactioncreator";

const EditCategory = ({ editData }) => {
    const [categoryData, setCategoryData] = useState({
        name: "",
        subCategoryType: "",
        subCategoryDescription: "",
        categoryId: "",
    });

    // const categoryOptions = [{
    //     "categoryId": "SWXaW31",
    //     "subCategoryType": "Sample1",
    //     "subCategoryDescription": "Sample1",
    //     "id": "2"
    // }];
    const [expenseList, setExpenseList] = useState('')

    const [categoryOptions, setcategoryOptions] = useState('')

    const [sidePopup, setPopup] = useState(false);
    const [popupStatus, setPopupStatus] = useState('');
    const [errors, setErrors] = useState({});

    const closePopup = () => {
        setPopup(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name !== 'id') {
            setCategoryData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };

    const validateForm = () => {
        let formErrors = {};
        let isValid = true;

        if (!categoryData.name) {
            formErrors.name = "Name is required";
            isValid = false;
        }
        if (!categoryData.subCategoryType) {
            formErrors.subCategoryType = "Subcategory Type is required";
            isValid = false;
        }
        if (!categoryData.subCategoryDescription) {
            formErrors.subCategoryDescription = "Subcategory Description is required";
            isValid = false;
        }
        if (!categoryData.categoryId) {
            formErrors.categoryId = "Category Id is required";
            isValid = false;
        }

        setErrors(formErrors);
        return isValid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            console.log("Category Data Saved", categoryData);
            if (editData.id) {
                categoryData.id = editData.id
                updateBusinessTargetSubCategoryData(categoryData, callback => {
                    if (callback.message === 'success') {
                        setPopup(true);
                        setPopupStatus('Data Saved Successfully!');
                    } else {
                        setPopup(true);
                        setPopupStatus('Please try again later!');
                    }
                    removePopup();
                });
            } else {
                saveBusinessTargetSubCategoryData(categoryData, callback => {
                    if (callback.message === 'success') {

                        setPopup(true);
                        setPopupStatus('Data Saved Successfully!');
                    } else {
                        setPopup(true);
                        setPopupStatus('Please try again later!');
                    }
                    removePopup();
                });
            }

        }
    };

    const removePopup = () => {
        setTimeout(() => {
            closePopup();
        }, 5000);
    };

    useEffect(() => {
        if (editData.id) {
            setCategoryData({
                name: editData.name || "",
                subCategoryType: editData.subCategoryType || "",
                subCategoryDescription: editData.subCategoryDescription || "",
                categoryId: editData.categoryId || "",
            });
        }
    }, [editData]);
    useEffect(() => {
        getAllBusinessTargetCategory(Callback => {
            setcategoryOptions(Callback.data)
        })

    }, [])
    return (
        <div className="container">
            {sidePopup && <Popup popupStatus={popupStatus} closePopup={closePopup} />}
            <div className="target-box">
                <h3>Add/Update Business Target Subcategory Information</h3>
                <hr style={{ borderTop: '1px solid #000' }} />
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-sm-6 col-xs-12">
                            <div style={{ display: 'flex', marginTop: '20px' }}>
                                <div style={{ width: '50%' }}>
                                    <label style={{ marginTop: '10px' }}>Name</label>
                                </div>
                                <div style={{ width: '50%' }}>
                                    <input
                                        style={{ background: '#fff', border: '1px solid' }}
                                        className="form-control"
                                        type="text"
                                        name="name"
                                        value={categoryData.name}
                                        onChange={handleChange}
                                    />
                                    {errors.name && (
                                        <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.name}</span>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-xs-12">
                            <div style={{ display: 'flex', marginTop: '20px' }}>
                                <div style={{ width: '50%' }}>
                                    <label style={{ marginTop: '10px' }}>Sub Category Type </label>
                                </div>
                                <div style={{ width: '50%' }}>
                                    <input
                                        style={{ background: '#fff', border: '1px solid' }}
                                        className="form-control"
                                        type="text"
                                        name="subCategoryType"
                                        value={categoryData.subCategoryType}
                                        onChange={handleChange}
                                    />
                                    {errors.subCategoryType && (
                                        <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.subCategoryType}</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">

                        <div className="col-sm-6 col-xs-12">
                            <div style={{ display: 'flex', marginTop: '20px' }}>
                                <div style={{ width: '50%' }}>
                                    <label style={{ marginTop: '10px' }}>Sub Category Description</label>
                                </div>
                                <div style={{ width: '50%' }}>
                                    <input
                                        style={{ background: '#fff', border: '1px solid' }}
                                        className="form-control"
                                        type="text"
                                        name="subCategoryDescription"
                                        value={categoryData.subCategoryDescription}
                                        onChange={handleChange}
                                    />
                                    {errors.subCategoryDescription && (
                                        <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.subCategoryDescription}</span>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-xs-12">
                            <div style={{ display: 'flex', marginTop: '20px' }}>
                                <div style={{ width: '50%' }}>
                                    <label style={{ marginTop: '10px' }}>Category Id</label>
                                </div>
                                <div style={{ width: '50%' }}>
                                    <select
                                        style={{ background: '#fff', border: '1px solid' }}
                                        className="form-control"
                                        name="categoryId"
                                        value={categoryData.categoryId}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select Category</option>
                                        {categoryOptions ? categoryOptions.map((category, i) => (
                                            <option key={category.id} value={category.categoryId}>
                                                {category.categoryDescription}
                                            </option>
                                        )) : ""}
                                    </select>
                                    {errors.categoryId && (
                                        <span style={{ color: 'red', fontSize: '10px', marginTop: '5px' }}>{errors.categoryId}</span>
                                    )}
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="text-center" style={{ marginTop: '40px' }}>
                        <button type="submit" className="btn btn-primary">Save Business Target Subcategory Data</button>
                    </div>
                </form>
            </div >
        </div >
    );
};

export default EditCategory;
